import { Alert, Box, Dialog, DialogContent, Grid, Typography } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import dayjs from 'dayjs';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useAppDispatch, useAppSelector } from '../../../../../../app/redux/hooks';
import {
  convertDatetoEpoch,
  convertTimeFormat,
  convertToEpoch3,
  findAddress,
  formatISTtoHHMM,
  formatISTtoTime,
  useAbort
} from '../../../../../../utils/commonFunctions';
import CustomIconButton from '../../../../../../common/components/buttons/CustomIconButton';
import CustomSelect from '../../../../../../common/components/customized/customselect/CustomSelect';
import CustomTextField from '../../../../../../common/components/customized/customtextfield/CustomTextField';
import GoogleSearchBox from '../../../../../../common/components/maps/googlesearchbox/GoogleSearchBox';
import CustomDateTimeCalendar from '../../../../../../common/components/customized/customdatetimecalendar/CustomDateTimeCalendar';
import CustomDateCalendar from '../../../../../../common/components/customized/customcalendar/CustomCalendar';
import CustomButton from '../../../../../../common/components/buttons/CustomButton';
import CustomTimePicker from '../../../../../../common/components/customized/customtimepicker/CustomTimePicker';
import GoogleMap from '../../../../../../common/components/maps/googlemap/GoogleMap';
import GoogleTripDirections from '../../../../../../common/components/maps/googledirection/GoogleTripDirections';
import CustomRadioButton from '../../../../../../common/components/customized/customradiobutton/CustomRadioButton';
import './AddTrip.scss';
import PhoneNoTextField from '../../../../../../common/components/customized/customtextfield/PhoneNoTextField';
import {
  AddAdhocVehicle,
  autoPlannerAddTripsAction,
  autoPlannerRoutesAction,
  autoPlannerUpdateTripsAction,
  clearAdhocTransferVehicle,
  clearAdhocVehicle,
  contactNumberValidation,
  getAdhocTransferVehicle,
  getAdhocVehicle,
  GetGrpBookings
} from '../../../../redux/reducer/autoPlannerSlices/autoplanner';
import {
  updateCenter,
  updateZoom
} from '../../../../../../common/redux/reducer/commonSlices/mapSlice';
import { getExcelAction } from '../../../../redux/reducer/autoPlannerSlices/autoGenerateSlice';
import { debounce } from 'lodash';
import { updateToast } from '../../../../../../common/redux/reducer/commonSlices/toastSlice';

interface Props {
  isOpen: boolean;
  setCallApi: any;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setTripMode?: any;
  selectedRow: any;
  setSelectedRow: any;
  pageDetails: { pageNo: number; pageSize: number; isAll?: boolean };
  Agents: { id: string; label: string }[];
  Routes: { id: string; label: string }[];
  selectedGroup?: any;
  mode?: string;
  filterPayload?: any;
  isViewAdhoc?: any;
}

interface Select {
  id: string;
  label: string;
}

interface UpdatePayload {
  tripID: number;
  journeyID: string;
  adultCount: number;
  agentName: string;
  childCount: number;
  date: string | null;
  destination: string | null;
  endLat: number | null;
  endLng: number | null;
  bufferTime: string | null;
  guestName: string;
  mode: string;
  refNumber: string;
  tourName: string | null;
  source: string | null;
  startLat: number | null;
  startLng: number | null;
  startTimestamp?: number | null;
  isScheduleModifying?: number;
  vehicleNumber?: string;
}

const AddAdhocTrip = ({
  isOpen,
  setCallApi,
  setIsOpen,
  selectedRow,
  setSelectedRow,
  pageDetailss,
  autoplannerID,
  setTripMode,
  Agents,
  Routes,
  mode,
  selectedGroup,
  filterPayload,
  isViewAdhoc,
  setBadgeCount
}: any) => {
  const [sourceAddress, setSourceAddress] = useState<any>(null);
  const [destinationAddress, setDestinationAddress] = useState<any>(null);
  const [tripType, setTripType] = useState<any>(null);
  const [timeReq, setTimeReq] = useState<any>(0);
  const [tourName, setTourName] = useState<any>(null);
  const [startDate, setStartDate] = useState<any>();
  const [tripMarker, setTripMarker] = useState<any>([]);
  const [pvtRoute, setPvtRoute] = useState<any>('Custom');
  const [vehicleType, setVehicleType] = useState<any>('Internal');
  const [transferVehicleType, setTransferVehicleType] = useState<any>('Internal');
  const [destinationMarker, setDestinationMarker] = useState<any>([]);
  const [isVehicleNumberEnable, setIsVehicleNumberEnable] = useState<any>(false);

  const tourNames = useAppSelector(state => state.autoPlannerRoutes.data || []);
  const [epocvalue, setEpocvalue] = useState<number | null>(null);
  const [validationErrors, setValidationErrorsMake] = useState<any>({
    phone: 'no-error',
    contactNumber: 'no-error',
    transferContactNumber: 'no-error'
  });

  const dispatch = useAppDispatch();
  const createAbort = useAbort();

  const { data: profileData } = useAppSelector(state => state.auth);

  let roletype = profileData?.role;

  const isAP = roletype === 'ROLE_AUTOPLANNER_ADMIN' || roletype === 'ROLE_OPERATOR';
  const APagent = roletype === 'ROLE_AGENT';
  const APsubAgent = roletype === 'ROLE_SUB_AGENT';

  const tourNameArray: string[] = tourNames.map((item: any) => item.tourName);

  //Today time zone (SG)
  const epochStartOfTodaySG = Math.floor(
    new Date(
      new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Singapore' }).format(
        new Date()
      ) + 'T00:00:00+08:00'
    ).getTime() / 1000
  );

  // const epochStartOfTommorowSG = Math.floor(
  //   (new Date(
  //     new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Singapore' }).format(
  //       new Date()
  //     ) + 'T00:00:00+08:00'
  //   ).getTime() +
  //     24 * 60 * 60 * 1000) /
  //     1000
  // );

  const configuredRoute = tourNames?.map((value: any) => ({
    id: value.tourName,
    label: value.tourName,
    is: value.isTimeRequired
  }));

  const { isLoading: BookingUpdateLoading } = useAppSelector(
    state => state.AutoPlannerAddTrip
  );
  const { isLoading } = useAppSelector(state => state.autoPlannerRoutes);
  const updateData = useAppSelector(state => state.AutoPlannerUpdateTrip);
  const { isLoading: updateAdhocLoading } = useAppSelector(
    state => state.AutoPlannerUpdateTrip
  );
  const { data } = useAppSelector(state => state.auth);
  const profile = useAppSelector(state => state.myProfile.data);
  const contactError = useAppSelector(state => state.ContactNumberValidation);

  const { data: adhocVehicle, isLoading: getAdhocLoading } = useAppSelector(
    state => state.getAdhocVehicle
  );
  const { data: adhocTransferVehicle, isLoading: getTransferAdhocLoading } =
    useAppSelector(state => state.getAdhocTransferVehicle);

  const { isLoading: AddAdhocLoading } = useAppSelector(state => state.AddAdhocVehicle);
  const { isLoading: sicBookingUpdateLoading } = useAppSelector(
    state => state.sicBookingsUpdate
  );
  const { isLoading: pvtBookingUpdateLoading } = useAppSelector(
    state => state.updatePvtGrpScheduled
  );

  const adhocDropdown = adhocVehicle?.data
    ?.map((item: any) => ({
      id: item?.vehicleNumber,
      label: `${item?.vehicleNumber?.toUpperCase()} (${item?.seatingCapacity})`,
      seatingCapacity: item?.seatingCapacity,
      group: item?.isAssignedToTour ? 'Used Vehicles (R)' : 'Unused vehicles (A)'
    }))
    .sort((a: any, b: any) => a.group.localeCompare(b.group))
    .sort((value: any) => (value.group === 'Unused vehicles (A)' ? 1 : -1));

  const adhocTransferDropdown = adhocTransferVehicle?.data?.transferVehicles
    ?.map((item: any) => ({
      id: item?.vehicleNumber,
      label: `${item?.vehicleNumber?.toUpperCase()} (${item?.seatingCapacity})`,
      seatingCapacity: item?.seatingCapacity,
      group: item?.isAssignedToTour ? 'Used Vehicles (R)' : 'Unused vehicles (A)'
    }))
    .sort((a: any, b: any) => a.group.localeCompare(b.group))
    .sort((value: any) => (value.group === 'Unused vehicles (A)' ? 1 : -1));

  let role = data?.role;

  const formatDate = (date: string | Date | null) => {
    return date ? dayjs(date).format('DD/MM/YYYY') : '';
  };

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const schema = () =>
    yup.object().shape({
      agentname: yup.string().required('Select agent name'),
      route: yup.string().optional(),
      phone: yup
        .string()
        .optional()
        .test('phone-error', 'Enter valid contact number', function (value: any) {
          if (validationErrors && value && validationErrors.phone !== 'no-error') {
            return this.createError({ message: validationErrors.phone });
          } else {
            return true;
          }
        }),
      referenceno: yup
        .string()
        .notRequired()
        .max(50, 'Reference no cannot exceed 50 characters'),
      guestname: yup
        .string()
        .required('Enter guest name')
        .matches(/^[A-Za-z.-]+(\s*[A-Za-z.-]+)*$/, 'Enter valid guest name')
        .min(3, 'Guest name must contain at least 3 characters')
        .max(50, 'Guest name cannot exceed 50 characters'),
      adultcount: yup
        .number()
        .typeError('Enter adult count')
        .required('Enter adult count')
        .min(1, 'Adult Count must be at least 1')
        .max(50, 'Adult Count must not exceed 50')
        .integer('Enter a valid adult count')
        .test(
          'is-whole-number',
          'Decimal values are not allowed',
          value => value === undefined || Number.isInteger(value)
        ),

      childcount: yup
        .number()
        .transform((value, originalValue) =>
          String(originalValue).trim() === '' ? undefined : value
        )
        .nullable()
        .notRequired()
        .min(0, 'Child count cannot be below 0')
        .max(50, 'Child count must not exceed 50')
        .typeError('Child count must be a number'),

      // .typeError('Child Count Cannot be Below 0'),
      triptype: yup.string().required('Select tour mode'),
      sourceAddress: yup.object().shape({
        source: yup.string().required('Select pickup location'),
        startLat: yup.number().required('Enter Latitude for Pickup Location'),
        startLng: yup.number().required('Enter Longitude for Pickup Location')
      }),
      destinationAddress: yup.object().when(['triptype'], {
        is: (triptype: any) =>
          (triptype === 'PVT' || triptype === 'GRP') && pvtRoute === 'Custom',
        then: () =>
          yup.object().shape({
            destination: yup.string().required('Select drop location'),
            endLat: yup.number().required('Enter Latitude for Drop Location'),
            endLng: yup.number().required('Enter Longitude for Drop Location')
          }),
        otherwise: () =>
          yup.object().shape({
            destination: yup.string().notRequired(),
            endLat: yup.number().notRequired(),
            endLng: yup.number().notRequired()
          })
      }),
      noSeats: yup.boolean().oneOf([true], 'Seating capacity reached').default(true),

      startdate: yup.mixed().when(['triptype', 'configuredRoute'], {
        is: (triptype: any, tourName: any) => {
          return (
            ['PVT', 'GRP'].includes(triptype) ||
            (
              ['SIC', 'TSIC'].includes(triptype) &&
              configuredRoute.find((item: any) => item.id === tourName)
            )?.is
          );
        },
        then: () =>
          yup
            .date()
            .typeError('Enter valid pickup date and time')
            .required('Select pickup date and time')
            .test('today-after-now', 'Invalid date and time', value => {
              if (!value) return false;
              const now = new Date(
                new Date().toLocaleString('en-US', { timeZone: profile?.timezone })
              );
              const selected = new Date(
                new Date(value).toLocaleString('en-US', { timeZone: profile?.timezone })
              );
              return selected.toDateString() === now.toDateString() && selected > now;
            }),
        otherwise: () => yup.mixed().notRequired()
      }),

      bufferTime: yup.object().when('triptype', {
        is: (value: any) =>
          (value === 'PVT' || value === 'GRP') && tourName == 'DISPOSAL 4 HRS',
        then: () =>
          yup
            .date()
            .optional()
            .test('is-valid-time', 'Invalid time format', value => {
              return true || null;
            }),
        otherwise: () => yup.string().notRequired()
      }),
      configuredRoute: yup.string().when('triptype', {
        is: (value: any) =>
          value === 'SIC' || value === 'TSIC' || pvtRoute === 'Standard',
        then: () => yup.string().required('Select tour name'),
        otherwise: () => yup.string().notRequired()
      }),
      tripDate: yup.string().when(['triptype', 'tourName'], {
        is: (triptype: any, tourname: any) =>
          (triptype === 'SIC' || triptype === 'TSIC') && timeReq === 0,
        then: () =>
          yup
            .string()
            .required('Select trip date')
            .matches(
              /^\d{2}\/\d{2}\/\d{4}$/,
              'Trip Date must be in the format DD/MM/YYYY'
            )
            .test('is-future-date', 'Trip date should be in present date', value => {
              const [day, month, year] = value.split('/');
              const today = Math.floor(new Date().setHours(0, 0, 0, 0) / 1000);
              const selectedDate = Math.floor(
                new Date(`${year}-${month}-${day}`).setHours(0, 0, 0, 0) / 1000
              );

              return today === selectedDate;
            }),
        otherwise: () => yup.string().notRequired()
      }),
      vehicleType: yup.string().notRequired(),
      vehicleNumber: yup.string().when(['vehicleType'], {
        is: (val: string) => val === 'Internal' && !APagent && !APsubAgent,
        then: schema => schema.required('Select vehicle number'),
        otherwise: schema =>
          APagent || APsubAgent
            ? schema.notRequired()
            : schema
                .required('Enter vehicle number')
                .matches(
                  /^[A-Za-z0-9]*$/,
                  'Only letters and numbers allowed without spaces'
                )
                .test(
                  'valid-length',
                  'Enter a valid vehicle number',
                  value => (value?.length || 0) >= 4
                )
                .max(20, 'Maximum 20 characters')
                .test('has-letter', 'Must include at least one letter', value =>
                  /[A-Za-z]/.test(value || '')
                )
      }),

      driverName: yup.string().when('$vehicleType', {
        is: (val: string) => {
          return val !== 'Internal';
        },
        then: schema =>
          schema
            .required('Enter driver name')
            .matches(/^[a-z,A-Z\s]+$/, 'Driver name must only contain characters')
            .min(3, 'Driver name must be more than 2 characters'),
        otherwise: schema => schema.notRequired()
      }),

      isTime: yup.boolean().notRequired(),

      seatingCapacity: yup.number().when('$vehicleType', {
        is: (val: string) => {
          return val !== 'Internal';
        },
        then: schema =>
          schema
            .required('Enter seating capacity')
            .min(1, 'Minimum seating capacity is 1')
            .max(249, 'Maximum seating capacity is 249')
            .transform((value, originalValue) => {
              return originalValue === '' ? undefined : value;
            })
            .typeError('Enter valid seating capacity'),

        otherwise: schema => schema.notRequired()
      }),

      contactNumber: yup.string().when('$vehicleType', {
        is: (val: string) => val !== 'Internal',
        then: schema =>
          schema
            .required('Enter driver contact number')
            .test(
              'contactNumber-error',
              'Enter a valid contact number',
              function (value: any) {
                if (value && validationErrors.contactNumber !== 'no-error') {
                  return this.createError({ message: validationErrors.contactNumber });
                } else {
                  return true;
                }
              }
            ),
        otherwise: schema => schema.notRequired()
      }),

      transferVehicleType: yup.string().notRequired(),

      transferVehicleNumber: yup
        .string()
        .when(['vehicleType', '$adhocTransferDropdown', 'triptype'], {
          is: (vehicleType: any, adhocTransferDropdown: any, triptype: any) => {
            return (
              vehicleType === 'Internal' &&
              Array.isArray(adhocTransferDropdown) &&
              adhocTransferDropdown?.length > 0 &&
              ['SIC', 'TSIC']?.includes(triptype)
            );
          },
          then: schema =>
            schema.when('$transferVehicleType', {
              is: (val: string) => val === 'Internal',
              then: schema => schema.required('Select transfer vehicle number'),
              otherwise: schema => schema.required('Enter transfer vehicle number')
            }),
          otherwise: schema => schema.notRequired()
        }),

      transferDriverName: yup.string().when('$transferVehicleType', {
        is: (val: string) => val !== 'Internal',
        then: schema =>
          schema
            .required('Enter driver name')
            .matches(/^[a-zA-Z\s]+$/, 'Driver name must only contain characters')
            .min(3, 'Driver name must be more than 2 characters'),
        otherwise: schema => schema.notRequired()
      }),

      transferContactNumber: yup.string().when('$transferVehicleType', {
        is: (val: string) => val !== 'Internal',
        then: schema =>
          schema
            .required('Enter transfer contact number')
            .test(
              'transfernumber-error',
              'Enter a valid contact number',
              function (value: any) {
                if (
                  value &&
                  validationErrors.transferContactNumber &&
                  validationErrors.transferContactNumber !== 'no-error'
                ) {
                  return this.createError({
                    message: validationErrors.transferContactNumber
                  });
                } else {
                  return true;
                }
              }
            ),
        otherwise: schema => schema.notRequired()
      }),

      transferCapacity: yup.number().when('$transferVehicleType', {
        is: (val: string) => {
          return val !== 'Internal';
        },
        then: schema =>
          schema
            .required('Enter seating capacity')
            .min(1, 'Minimum seating capacity is 1')
            .max(249, 'Maximum seating capacity is 249')
            .transform((value, originalValue) => {
              return originalValue === '' ? undefined : value;
            })
            .typeError('Enter valid seating capacity'),

        otherwise: schema => schema.notRequired()
      })
    });

  const {
    control,
    handleSubmit,
    setValue,
    clearErrors,
    getValues,
    trigger,
    reset,
    resetField,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema()),
    context: {
      vehicleType,
      transferVehicleType,
      adhocTransferDropdown
    }
  });

  const address = async (lat: any, lng: any) => {
    let fAdd = findAddress(lat, lng);
    return fAdd;
  };

  const handleValidate = useCallback(
    debounce(async (event: any, field: string) => {
      const response: any = await dispatch(contactNumberValidation(event));
      setValidationErrorsMake((prev: any) => ({
        ...prev,
        [field]: response?.payload?.status !== 200 ? response.payload : 'no-error'
      }));
    }, 200),
    []
  );
  const handleClose = () => {
    dispatch(clearAdhocTransferVehicle());
    setSelectedRow(null);
    setValidationErrorsMake({ phone: '', contactNumber: '', transferContactNumber: '' });
    setIsOpen(false);
    reset();
    setCallApi(false);
  };

  function formatDates(dateString: any) {
    const date = new Date(dateString as any);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();

    return `${day}/${month}/${year}`;
  }

  const handleVehicleDropdown = async () => {
    dispatch(clearAdhocVehicle());
    dispatch(clearAdhocTransferVehicle());
    setValue('vehicleNumber', '');
    setIsVehicleNumberEnable(false);
    const SICTSICFields = [
      'agentname',
      'adultcount',
      getValues('isTime') ? 'startdate' : 'tripDate',
      'guestname',
      'triptype',
      'configuredRoute',
      'sourceAddress'
    ];

    const PVTGRPCustomFields: any = [
      'agentname',
      'adultcount',
      'guestname',
      'triptype',
      'sourceAddress',
      'route',
      'destinationAddress',
      'startdate'
    ];

    const PVTGRPStandardFields: any = [
      'agentname',
      'adultcount',
      'guestname',
      'triptype',
      'sourceAddress',
      'route',
      'configuredRoute',
      getValues('isTime') ? 'startdate' : 'tripDate'
    ];
    const fields = ['SIC', 'TSIC'].includes(getValues('triptype'))
      ? SICTSICFields
      : getValues('route') === 'Custom'
      ? PVTGRPCustomFields
      : PVTGRPStandardFields;

    const callApi = fields?.every((item: any) => {
      return Boolean(
        getValues(item) &&
          (['sourceAddress', 'destinationAddress']?.includes(item)
            ? Object.values(getValues(item))?.every(Boolean)
            : true) &&
          (['adultcount']?.includes(item) ? Boolean(Number(getValues(item))) : true)
      );
    });

    if (callApi && getValues('vehicleType')) {
      const standard = tripType === 'SIC' || tripType === 'TSIC';
      const bufferTimeFormatted =
        !standard && getValues('bufferTime' as any)?.$d
          ? formatISTtoTime(getValues('bufferTime' as any)?.$d)
          : null;
      const payloadData = {
        adultCount: getValues('adultcount'),
        agentName: getValues('agentname') ? getValues('agentname') : 0,
        childCount: getValues('childcount') ? getValues('childcount') : 0,
        date: getValues('tripDate') ? getValues('tripDate') : '',
        ...(getValues('destinationAddress' as any) &&
        !(tripType === 'SIC' || tripType === 'TSIC')
          ? {
              destination: getValues('destinationAddress' as any)?.destination || '',
              endLat: getValues('destinationAddress' as any)?.endLat || ' ',
              endLng: getValues('destinationAddress' as any)?.endLng || ''
            }
          : {}),
        ...(getValues('phone') &&
          getValues('phone')?.includes('-') &&
          getValues('phone')?.split('-')[1] && {
            guestContactNumber: getValues('phone')
          }),
        source: getValues('sourceAddress')?.source ?? '',
        startLat: getValues('sourceAddress')?.startLat ?? '',
        startLng: getValues('sourceAddress')?.startLng ?? '',
        guestName: getValues('guestname') ?? '',
        mode: getValues('triptype') ?? '',
        refNumber: getValues('referenceno') ?? '',
        tourName: getValues('configuredRoute') ?? '',

        ...(['PVT', 'GRP']?.includes(tripType)
          ? { isCustomRoute: getValues('route') === 'Custom' ? 1 : 0 }
          : { isCustomRoute: 0 }),
        time: getValues('startdate')
          ? convertTimeFormat(formatISTtoHHMM(getValues('startdate' as any)?.$d))
          : null,
        startTimestamp: getValues('startdate')
          ? convertDatetoEpoch(getValues('startdate' as any)?.$d) / 1000
          : null,
        bufferTime: bufferTimeFormatted
      };

      const payload = {
        date: epochStartOfTodaySG,
        data: payloadData
      };
      setIsVehicleNumberEnable(true);
      if (vehicleType === 'Internal') {
        const res: any = await dispatch(getAdhocVehicle(payload));
        if (res?.payload?.data?.length === 0) {
          dispatch(
            updateToast({
              show: true,
              message:
                'Internal vehicle is not available. Please add an external vehicle.',
              severity: 'warning'
            })
          );
        }
      }
    }
  };

  const handleTansferVehicleDropdown = async (params: any) => {
    const standard = tripType === 'SIC' || tripType === 'TSIC';
    const bufferTimeFormatted =
      !standard && getValues('bufferTime' as any)?.$d
        ? formatISTtoTime(getValues('bufferTime' as any)?.$d)
        : null;

    const payloadData = {
      adultCount: getValues('adultcount'),
      agentName: getValues('agentname') ? getValues('agentname') : 0,
      childCount: getValues('childcount') ? getValues('childcount') : 0,
      date: getValues('tripDate') ? getValues('tripDate') : '',
      ...(getValues('destinationAddress' as any)
        ? {
            destination: getValues('destinationAddress' as any)?.destination || '',
            endLat: getValues('destinationAddress' as any)?.endLat || ' ',
            endLng: getValues('destinationAddress' as any)?.endLng || ''
          }
        : {}),
      ...(getValues('phone') &&
        getValues('phone')?.includes('-') &&
        getValues('phone')?.split('-')[1] && {
          guestContactNumber: getValues('phone')
        }),
      source: getValues('sourceAddress')?.source ?? '',
      startLat: getValues('sourceAddress')?.startLat ?? '',
      startLng: getValues('sourceAddress')?.startLng ?? '',
      guestName: getValues('guestname') ?? '',
      mode: getValues('triptype') ?? '',
      refNumber: getValues('referenceno') ?? '',
      tourName: getValues('configuredRoute') ?? '',
      ...(['PVT', 'GRP']?.includes(tripType)
        ? { isCustomRoute: getValues('route') === 'Custom' ? 1 : 0 }
        : { isCustomRoute: 0 }),
      time: getValues('startdate')
        ? convertTimeFormat(formatISTtoHHMM(getValues('startdate' as any)?.$d))
        : null,
      startTimestamp: getValues('startdate')
        ? convertDatetoEpoch(getValues('startdate' as any)?.$d) / 1000
        : null,
      bufferTime: bufferTimeFormatted,
      isExternalVehicle: vehicleType === 'Internal' ? 0 : 1,
      vehicleNumber: params?.id,
      seatingCapacity: params?.seatingCapacity
    };
    const payload = {
      date: epochStartOfTodaySG,
      data: payloadData
    };

    if (
      (tripType === 'SIC' || tripType === 'TSIC') &&
      transferVehicleType === 'Internal'
    ) {
      const res: any = await dispatch(getAdhocTransferVehicle(payload));

      if (
        res?.payload?.data?.mainHotelResponses?.length > 0 &&
        res?.payload?.data?.transferVehicles?.length === 0
      ) {
        dispatch(
          updateToast({
            show: true,
            message:
              'Internal Transfer vehicle is not available. Please add an external vehicle.',
            severity: 'warning'
          })
        );
      }
    }
  };

  //     let GRPPVTpayload: any = {
  //       agentName: params.agentname,
  //       guestName: params.guestname,
  //       source: params.sourceAddress.source,
  //       startLat: params.sourceAddress.startLat,
  //       startLng: params.sourceAddress.startLng,
  //       destination: params?.destinationAddress?.destination,
  //       endLat: params.destinationAddress.endLat,
  //       endLng: params.destinationAddress.endLng,
  //       time: getValues('startdate')
  //         ? convertEpochToTime(getValues('startdate' as any)?.$d)
  //         : '',
  //       childCount: params.childcount,
  //       ...(params.phone &&
  //         params.phone.includes('-') &&
  //         params.phone.split('-')[1] && { guestContactNumber: params.phone }),
  //       isCustomRoute: params?.route === 'Custom' ? 1 : 0,
  //       seatingCapacity: params.passengerCount
  //         ? params.passengerCount
  //         : selectedRow.seatingCapacity,
  //       adultCount: params.adultcount,
  //       refNumber: params.referenceno,
  //       tourName: selectedRow.destination,
  //       vehicleNumber:
  //         params.vehicleNumber === 'Unassigned' ? null : params.vehicleNumber,
  //       driverName: params.driverName === 'Unassigned' ? null : params.driverName ?? '',
  //       contactNumber:
  //         params.contactNumber === 'Unassigned' ? null : params.contactNumber,
  //       isExternalVehicle: params.vehicle === 'External' ? 1 : 0,
  //       journeyId: selectedRow.journeyId,
  //       driverID: selectedRow.driverID === 'Unassigned' ? null : selectedRow.driverID,
  //       modifyVehicleDriver: selectedRow.modifyVehicleDrivera
  //     };
  //     let SICTSICPayload: any = {
  //       id: selectedRow.id,
  //       agentName: params.agentname,
  //       guestName: params.guestname,
  //       source: params.sourceAddress.source,
  //       startLat: params.sourceAddress.startLat,
  //       startLng: params.sourceAddress.startLng,
  //       destination: selectedRow.destination,
  //       endLat: selectedRow.endLat,
  //       returnTime: selectedRow?.pickupWindow
  //         ? selectedRow.returnTime
  //         : formatISTtoTime(params.time),
  //       endLng: selectedRow.endLng,
  //       time: selectedRow?.time,
  //       childCount: params.childcount,
  //       ...(selectedRow?.pickupWindow ? { pickupWindow: selectedRow?.pickupWindow } : {}),
  //       adultCount: params.adultcount,
  //       refNumber: params.referenceno,
  //       vehicleNumber: params.vehicleNumber,
  //       isCustomRoute: 0,
  //       driverName: params.driverName ? params.driverName : selectedRow?.driverName,
  //       isExternalVehicle: vehicleType === 'External' ? 1 : 0,
  //       modifyVehicleDriver: 0,
  //       driverId: selectedRow?.driverId,
  //       ...(params.phone &&
  //         params.phone.includes('-') &&
  //         params.phone.split('-')[1] && { guestContactNumber: params.phone }),
  //       // driverContactNumber: '9822681878',
  //       externalVehicleView:
  //         vehicleType === 'Internal'
  //           ? null
  //           : {
  //               vehicleNumber: params.vehicleNumber,
  //               driverName: params.driverName,
  //               mobileNumber: params.contactNumber,
  //               driverID: `${params?.driverName}-${params?.contactNumber}`,
  //               isExternalVehicle: 1,
  //               seatingCapacity: params.seatingCapacity,
  //               isActive: selectedRow?.externalVehicleView?.isActive
  //             },
  //       // transferInstance: { ...selectedRow.transferInstance },
  //       ...(vehicleType === 'Internal' &&
  //         adhocTransferDropdown?.length > 0 && {
  //           transferInstance:
  //             transferVehicleType === 'Internal'
  //               ? {
  //                   ...selectedRow.transferInstance,
  //                   vehicleNumber: params?.transferVehicleNumber,
  //                   seatingCapacity: adhocTransferDropdown?.find(
  //                     (item: any) => item?.id === params?.transferVehicleNumber
  //                   )?.seatingCapacity,
  //                   isExternalVehicle: 0
  //                 }
  //               : {
  //                   ...selectedRow.transferInstance,
  //                   vehicleNumber: params?.transferVehicleNumber,
  //                   isExternalVehicle: 1,
  //                   driverName: params?.transferDriverName,
  //                   contactNumber: params?.transferContactNumber,
  //                   seatingCapacity: params?.transferCapacity
  //                 }
  //         }),

  //       isReturnTrip: selectedRow.isReturnTrip ?? null,
  //       tourName: selectedRow.tourName,
  //       journeyId: selectedRow.journeyId || null,
  //       mainHotelResponses:
  //         selectedRow.mainHotelResponses?.length > 0
  //           ? selectedRow.mainHotelResponses
  //           : null
  //     };

  //     const pageDetails = {
  //       ...pageDetailss,
  //       ...filterPayload,
  //       isCurrentSchedule: true,
  //       autoplannerID: epochStartOfTodaySG,
  //       tripMode: tripType,
  //       id: selectedRow?.id
  //     };
  //     const data = {
  //       payload:
  //         tripType === 'SIC' || tripType === 'TSIC' ? SICTSICPayload : GRPPVTpayload,
  //       pageDetails
  //     };

  //     if (tripType === 'SIC' || tripType === 'TSIC') {
  //       const action = await dispatch(sicBookingsUpdate(data as any));
  //       if (action.type === sicBookingsUpdate.fulfilled.type) {
  //         const payload = {
  //           PageNo: pageDetailss?.pageNo,
  //           PageSize: pageDetailss?.pageSize,
  //           autoplannerID: epochStartOfTodaySG,
  //           tripMode: 'ALL'
  //         };
  //         await dispatch(getExcelAction(payload));
  //         handleClose();
  //       }
  //     } else {
  //       const action = await dispatch(PvtGrpUpdate(data));
  //       if (action.type === PvtGrpUpdate.fulfilled.type) {
  //         const payload = {
  //           PageNo: pageDetailss?.pageNo,
  //           PageSize: pageDetailss?.pageSize,
  //           autoplannerID: epochStartOfTodaySG,
  //           tripMode: 'ALL'
  //         };
  //         await dispatch(getExcelAction(payload));
  //         handleClose();
  //       }
  //     }
  //   } else {
  //     const standard = tripType === 'SIC' || tripType === 'TSIC';
  //     const bufferTimeFormatted =
  //       !standard && params.bufferTime ? formatISTtoTime(params.bufferTime) : null;
  //     const payload = {
  //       adultCount: params.adultcount,
  //       agentName: params?.agentname ? params?.agentname : 0,
  //       childCount: params.childcount ? params.childcount : 0,
  //       date: params.tripDate ? params.tripDate : null,
  //       destination:
  //         pvtRoute === 'Custom' || !standard
  //           ? params.destinationAddress?.destination ?? null
  //           : null,
  //       endLat:
  //         pvtRoute === 'Custom' || !standard
  //           ? params.destinationAddress?.endLat ?? null
  //           : null,
  //       endLng:
  //         pvtRoute === 'Custom' || !standard
  //           ? params.destinationAddress?.endLng ?? null
  //           : null,
  //       guestName: params.guestname,
  //       mode: params.triptype,
  //       refNumber: params?.referenceno ? params?.referenceno : '',
  //       tourName: params?.configuredRoute ? params?.configuredRoute : null,
  //       source: params.sourceAddress?.source ?? null,
  //       startLat: params.sourceAddress?.startLat ?? null,
  //       ...(params.phone &&
  //         params.phone.includes('-') &&
  //         params.phone.split('-')[1] && { guestContactNumber: params.phone }),

  //       startLng: params.sourceAddress?.startLng ?? null,
  //       ...(['PVT', 'GRP']?.includes(tripType)
  //         ? { isCustomRoute: pvtRoute === 'Custom' ? 1 : 0 }
  //         : {}),
  //       time: params.startdate ? convertEpochToTime(params.startdate) : null,
  //       startTimestamp: params.startdate
  //         ? convertDatetoEpoch(params.startdate) / 1000
  //         : null,
  //       bufferTime: bufferTimeFormatted,
  //       isExternalVehicle: vehicleType === 'External' ? 1 : 0,
  //       vehicleNumber: params?.vehicleNumber,
  //       ...(vehicleType === 'Internal'
  //         ? {
  //             seatingCapacity: adhocDropdown?.find(
  //               (item: any) => item?.id === params?.vehicleNumber
  //             )?.seatingCapacity
  //           }
  //         : { seatingCapacity: params?.seatingCapacity }),
  //       ...(vehicleType !== 'Internal'
  //         ? { driverName: params?.driverName, contactNumber: params?.contactNumber }
  //         : {}),

  //       ...(vehicleType === 'Internal' && adhocTransferDropdown?.length > 0
  //         ? { transferVehicleNumber: params?.transferVehicleNumber }
  //         : {}),

  //       ...(vehicleType === 'Internal' && transferVehicleType !== 'Internal'
  //         ? {
  //             transferDriverName: params?.transferDriverName,
  //             transferContactNumber: params?.transferContactNumber
  //           }
  //         : {}),

  //       ...(adhocTransferVehicle?.data?.mainHotelResponses?.length > 0
  //         ? { mainHotelResponse: adhocTransferVehicle?.data?.mainHotelResponses[0] }
  //         : {}),
  //       ...(adhocTransferDropdown?.length > 0 && transferVehicleType === 'Internal'
  //         ? {
  //             transferCapacity: adhocTransferDropdown?.find(
  //               (item: any) => item?.id === params?.transferVehicleNumber
  //             )?.seatingCapacity
  //           }
  //         : { transferCapacity: params?.transferCapacity }),

  //       ...(adhocTransferDropdown?.length > 0 && {
  //         isExternalTransfer: transferVehicleType === 'External' ? 1 : 0
  //       })
  //     };

  //     const addAdhocTrips = { date: epochStartOfTodaySG, data: payload };
  //     const res = await dispatch(AddAdhocVehicle(addAdhocTrips));
  //     if (res?.meta?.requestStatus === 'fulfilled') {
  //       const payload = {
  //         PageNo: pageDetailss?.pageNo,
  //         PageSize: pageDetailss?.pageSize,
  //         autoplannerID: epochStartOfTodaySG,
  //         tripMode: 'ALL'
  //       };
  //       await dispatch(getExcelAction(payload));
  //       handleClose();
  //     }
  //   }
  //   // if (setTripMode && !pageDetails.isAll)
  //   //   setTripMode(
  //   //     null,
  //   //     payload.mode === 'SIC'
  //   //       ? 0
  //   //       : payload.mode === 'TSIC'
  //   //       ? 1
  //   //       : payload.mode === 'PVT'
  //   //       ? 2
  //   //       : 3
  //   //   );
  // };

  const onSubmit = async (params: any) => {
    const standard = tripType === 'SIC' || tripType === 'TSIC';
    const bufferTimeFormatted =
      !standard && params.bufferTime ? formatISTtoTime(params.bufferTime) : null;
    const payload = {
      adultCount: params.adultcount,
      agentName: params?.agentname ? params?.agentname : 0,
      childCount: params.childcount ? params.childcount : 0,
      date: params.tripDate ? params.tripDate : null,
      destination:
        pvtRoute === 'Custom' || !standard
          ? params.destinationAddress?.destination ?? null
          : null,
      endLat:
        pvtRoute === 'Custom' || !standard
          ? params.destinationAddress?.endLat ?? null
          : null,
      endLng:
        pvtRoute === 'Custom' || !standard
          ? params.destinationAddress?.endLng ?? null
          : null,
      guestName: params.guestname,
      mode: params.triptype,
      refNumber: params?.referenceno ? params?.referenceno : '',
      tourName: params?.configuredRoute ? params?.configuredRoute : null,
      source: params.sourceAddress?.source ?? null,
      startLat: params.sourceAddress?.startLat ?? null,
      ...(params.phone &&
        params.phone.includes('-') &&
        params.phone.split('-')[1] && { guestContactNumber: params.phone }),

      startLng: params.sourceAddress?.startLng ?? null,
      ...(['PVT', 'GRP']?.includes(tripType)
        ? { isCustomRoute: pvtRoute === 'Custom' ? 1 : 0 }
        : { isCustomRoute: 0 }),
      time: params.startdate
        ? convertTimeFormat(formatISTtoHHMM(params.startdate))
        : null,
      startTimestamp: params.startdate
        ? convertDatetoEpoch(params.startdate) / 1000
        : null,
      bufferTime: bufferTimeFormatted,
      ...(!APagent &&
        !APsubAgent && {
          isExternalVehicle: vehicleType === 'External' ? 1 : 0
        }),
      ...(!APagent && !APsubAgent && { vehicleNumber: params?.vehicleNumber }),
      ...(vehicleType === 'Internal'
        ? {
            seatingCapacity: adhocDropdown?.find(
              (item: any) => item?.id === params?.vehicleNumber
            )?.seatingCapacity
          }
        : { seatingCapacity: params?.seatingCapacity }),
      ...(vehicleType !== 'Internal'
        ? { driverName: params?.driverName, contactNumber: params?.contactNumber }
        : {}),

      ...(vehicleType === 'Internal' && adhocTransferDropdown?.length > 0
        ? { transferVehicleNumber: params?.transferVehicleNumber }
        : {}),

      ...(vehicleType === 'Internal' && transferVehicleType !== 'Internal'
        ? {
            transferDriverName: params?.transferDriverName,
            transferContactNumber: params?.transferContactNumber
          }
        : {}),

      ...(adhocTransferVehicle?.data?.mainHotelResponses?.length > 0
        ? { mainHotelResponse: adhocTransferVehicle?.data?.mainHotelResponses[0] }
        : {}),
      ...(adhocTransferDropdown?.length > 0 && transferVehicleType === 'Internal'
        ? {
            transferCapacity: adhocTransferDropdown?.find(
              (item: any) => item?.id === params?.transferVehicleNumber
            )?.seatingCapacity
          }
        : { transferCapacity: params?.transferCapacity }),

      ...(adhocTransferVehicle?.data?.mainHotelResponses?.length > 0 && {
        isExternalTransfer: transferVehicleType === 'External' ? 1 : 0
      }),
      ...(selectedRow?.journeyId && { journeyID: selectedRow?.journeyId }),
      ...(selectedRow?.tripID && { tripID: selectedRow?.tripID })
    };

    const addAdhocTrips = selectedRow
      ? {
          date: epochStartOfTodaySG,
          data: payload,
          journeyID: selectedRow?.journeyId,
          method: 'PUT'
        }
      : { date: epochStartOfTodaySG, data: payload, method: 'POST' };

    if (APagent || APsubAgent) {
      const action1 = selectedRow
        ? await dispatch(
            autoPlannerUpdateTripsAction({ payload, APagent, APsubAgent, selectedRow })
          )
        : await dispatch(autoPlannerAddTripsAction({ payload, APagent, APsubAgent }));

      if (
        action1.type === autoPlannerAddTripsAction.fulfilled.type ||
        action1.type === autoPlannerUpdateTripsAction.fulfilled.type
      ) {
        handleClose();

        const res: any = await dispatch(
          GetGrpBookings({
            mode: 'ALL',
            pageNo: 1,
            pageSize: 20,
            autoplannerID: autoplannerID,
            isAdhoc: true
          })
        );
        setBadgeCount(res?.payload?.data?.count ?? 0);
      }
    } else {
      const res = await dispatch(AddAdhocVehicle(addAdhocTrips));
      if (res.type === AddAdhocVehicle.fulfilled.type) {
        const payload = {
          PageNo: pageDetailss?.pageNo,
          PageSize: pageDetailss?.pageSize,
          autoplannerID: epochStartOfTodaySG,
          tripMode: 'ALL'
        };
        handleClose();

        await dispatch(getExcelAction(payload));

        const res: any = await dispatch(
          GetGrpBookings({
            mode: 'ALL',
            pageNo: 1,
            pageSize: 20,
            autoplannerID: autoplannerID,
            isAdhoc: true
          })
        );
        setBadgeCount(res?.payload?.data?.count ?? 0);
      }
    }
  };
  const tripTypes = [
    { id: 'PVT', label: 'PVT' },
    { id: 'SIC', label: 'SIC' },
    { id: 'TSIC', label: 'TSIC' },
    { id: 'GRP', label: 'GRP' }
  ];

  const handleMarkerDrag = async (e: any, marker: any) => {
    if (marker === 'source') {
      const newAddress = await address(e?.latLng?.lat(), e?.latLng?.lng());
      setSourceAddress({
        geometry: {
          location: {
            lat: () => {
              return e?.latLng?.lat();
            },
            lng: () => {
              return e?.latLng?.lng();
            }
          }
        },
        formatted_address: newAddress
      });
    } else if (marker === 'destination') {
      const newAddress = await address(e?.latLng?.lat(), e?.latLng?.lng());
      setDestinationAddress({
        geometry: {
          location: {
            lat: () => {
              return e?.latLng?.lat();
            },
            lng: () => {
              return e?.latLng?.lng();
            }
          }
        },
        formatted_address: newAddress
      });
    }
  };

  useEffect(() => {
    if (selectedRow?.tripID) {
      if (selectedRow?.bufferTime) {
        const bufferTime = selectedRow.bufferTime ?? '00:00';
        setValue(
          'bufferTime',
          dayjs()
            .set('hour', bufferTime.split(':')[0])
            .set('minute', bufferTime.split(':')[1])
        );
      } else {
        setValue('bufferTime', dayjs('00:20', 'HH:mm'));
      }

      setEpocvalue(convertToEpoch3(selectedRow?.date ?? ''));

      setValue('agentname', selectedRow?.agentName?.toLowerCase() ?? '');
      setValue('triptype', selectedRow?.mode ?? mode);

      dispatch(
        autoPlannerRoutesAction({
          mode: selectedRow?.mode ?? mode,
          currentSecond: dayjs()
            .tz(profile.timezone)
            .format('HH:mm:ss')
            .split(':')
            .map(Number)
            .reduce((acc: any, time: any) => 60 * acc + +time)
        })
      );

      setValue('referenceno', selectedRow?.refNumber ?? '');
      setValue('guestname', selectedRow?.guestName ?? '');
      setValue('adultcount', selectedRow?.adultCount ?? 0);
      setValue('childcount', selectedRow?.childCount ?? 0);
      setTripType(selectedRow?.mode ?? mode);
      setValue(
        'vehicleType',
        selectedRow?.isExternalVehicle === 0 ? 'Internal' : 'External'
      );

      setValue('route', selectedRow?.isCustomRoute === 1 ? 'Custom' : 'Standard');
      setValue('configuredRoute', selectedRow?.tourName ?? selectedGroup?.tourName);
      setValue(
        'vehicleNumber',
        selectedRow?.vehicleNumber ?? selectedGroup?.vehicleNumber
      );

      setTripMarker([
        {
          id: 'source',
          lat: selectedRow?.startLat,
          lng: selectedRow?.startLng,
          name: 'trip',
          info: { Mylocation: 'source' }
        }
      ]);

      setSourceAddress({
        geometry: {
          location: {
            lat: () => selectedRow?.startLat,
            lng: () => selectedRow?.startLng
          }
        },
        formatted_address: selectedRow?.source ?? ''
      });

      if (selectedRow?.destination !== selectedRow?.tourName) {
        setDestinationAddress({
          geometry: {
            location: {
              lat: () => selectedRow?.endLat,
              lng: () => selectedRow?.endLng
            }
          },
          formatted_address: selectedRow?.destination ?? ''
        });
      }

      // Optional: handle startTimestamp if available in future
      // if (selectedRow?.startTimestamp) {
      //   setValue(
      //     'startdate',
      //     dayjs.unix(convertDateTimetoEpoch(selectedRow.startTimestamp) / 1000)
      //   );
      //   setStartDate(
      //     dayjs.unix(convertDateTimetoEpoch(selectedRow.startTimestamp) / 1000)
      //   );
      // }

      const todayDate = dayjs().format('DD-MM-YYYY');
      const value = dayjs(`${todayDate} ${selectedRow?.time}`, 'DD-MM-YYYY HH:mm');

      setStartDate(dayjs.unix(selectedRow?.startTimestamp));

      setValue('startdate', dayjs.unix(selectedRow?.startTimestamp));

      setVehicleType(selectedRow?.isExternalVehicle ? 'External' : 'Internal');

      const payloadAdhocData = {
        adultCount: selectedRow?.adultCount ?? 0,
        agentName: selectedRow?.agentName ?? '',
        childCount: selectedRow?.childCount ?? 0,
        date: dayjs().format('DD/MM/YYYY'),

        ...((selectedRow?.destination && selectedRow?.isCustomRoute) ||
        selectedRow?.transferInstance?.to
          ? {
              destination:
                selectedRow?.destination ??
                selectedRow?.transferInstance?.to?.locationAddress ??
                '',
              endLat: selectedRow?.endLat ?? selectedRow?.transferInstance?.to?.lat ?? '',
              endLng: selectedRow?.endLng ?? selectedRow?.transferInstance?.to?.lng ?? ''
            }
          : {}),

        ...(selectedRow?.guestContactNumber && {
          guestContactNumber: selectedRow.guestContactNumber
        }),

        source:
          selectedRow?.source ??
          selectedRow?.transferInstance?.from?.locationAddress ??
          '',
        startLat: selectedRow?.startLat ?? selectedRow?.transferInstance?.from?.lat ?? '',
        startLng: selectedRow?.startLng ?? selectedRow?.transferInstance?.from?.lng ?? '',

        guestName: selectedRow?.guestName ?? '',
        mode: selectedRow?.mode ?? '',
        refNumber: selectedRow?.refNumber ?? '',
        tourName: selectedRow?.tourName ?? '',

        isCustomRoute: selectedRow?.isCustomRoute ?? 0,

        time: selectedRow?.time ?? selectedRow?.transferInstance?.time ?? null,
        startTimestamp: selectedRow?.startTimestamp ?? null,
        bufferTime: selectedRow?.bufferTime ?? ''
      };

      const payload = {
        date: epochStartOfTodaySG,
        data: payloadAdhocData
      };
      setIsVehicleNumberEnable(true);
      dispatch(getAdhocVehicle(payload));

      if (selectedRow?.transferInstance) {
        const payloadData = {
          adultCount: selectedRow?.adultCount ?? 0,
          agentName: selectedRow?.agentName ?? '',
          childCount: selectedRow?.childCount ?? 0,
          date: dayjs().format('DD/MM/YYYY'),

          destination:
            selectedRow?.destination ??
            selectedRow?.transferInstance?.to?.locationAddress ??
            '',
          endLat: selectedRow?.endLat ?? selectedRow?.transferInstance?.to?.lat ?? '',
          endLng: selectedRow?.endLng ?? selectedRow?.transferInstance?.to?.lng ?? '',

          ...(selectedRow?.guestContactNumber && {
            guestContactNumber: selectedRow.guestContactNumber
          }),

          source:
            selectedRow?.source ??
            selectedRow?.transferInstance?.from?.locationAddress ??
            '',
          startLat:
            selectedRow?.startLat ?? selectedRow?.transferInstance?.from?.lat ?? '',
          startLng:
            selectedRow?.startLng ?? selectedRow?.transferInstance?.from?.lng ?? '',

          guestName: selectedRow?.guestName ?? '',
          mode: selectedRow?.mode ?? '',
          refNumber: selectedRow?.refNumber ?? '',
          tourName: selectedRow?.tourName ?? '',
          isCustomRoute: selectedRow?.isCustomRoute ?? 0,

          time: selectedRow?.time ?? selectedRow?.transferInstance?.time ?? null,
          startTimestamp: selectedRow?.startTimestamp ?? null,
          bufferTime: selectedRow?.bufferTime ?? '',

          isExternalVehicle: selectedRow?.isExternalVehicle ?? 0,
          vehicleNumber: selectedRow?.vehicleNumber ?? '',
          seatingCapacity: selectedRow?.seatingCapacity ?? 0,

          driverId: selectedRow?.driverId ?? '',
          driverName: selectedRow?.driverName ?? '',
          driverContactNumber: selectedRow?.driverContactNumber ?? ''
        };

        const payload = {
          date: epochStartOfTodaySG,
          data: payloadData
        };

        if (['SIC', 'TSIC'].includes(selectedRow?.mode)) {
          dispatch(getAdhocTransferVehicle(payload));
        }
      }
      setIsVehicleNumberEnable(true);

      setValue('transferVehicleNumber', selectedRow?.transferInstance?.vehicleNumber);
      setValue('driverName', selectedRow?.driverName);
      setTransferVehicleType(
        selectedRow?.transferInstance?.isExternalVehicle ? 'External' : 'Internal'
      );
      setValue(
        'transferVehicleType',
        selectedRow?.transferInstance?.isExternalVehicle ? 'External' : 'Internal'
      );
      setValue('contactNumber', selectedRow?.driverContactNumber);
      setValue('seatingCapacity', selectedRow?.seatingCapacity);
    }
  }, [selectedRow]);

  useEffect(() => {
    if (selectedRow && tourNames?.length > 0) {
      const time = tourNames?.find(
        (item: any) => item?.tourName === selectedRow?.tourName
      );
      setValue('isTime', Boolean(time?.isTimeRequired));
      setTimeReq(time?.isTimeRequired);
    }
  }, [selectedRow, tourNames]);

  useEffect(() => {
    if (selectedRow?.tourName) {
      setPvtRoute('Standard');
    } else {
      setPvtRoute('Custom');
    }
  }, [selectedRow]);

  useEffect(() => {
    setValue('sourceAddress', {
      source: sourceAddress?.formatted_address,
      startLat: sourceAddress?.geometry?.location?.lat(),
      startLng: sourceAddress?.geometry?.location?.lng()
    });
    clearErrors('sourceAddress');
    const prevMarkers = tripMarker;
    if (prevMarkers?.length <= 1 && sourceAddress) {
      // setTripMarker([
      //   {
      //     id: 'source',
      //     lat: sourceAddress?.geometry?.location?.lat(),
      //     lng: sourceAddress?.geometry?.location?.lng(),
      //     name: 'trip',
      //     info: { Mylocation: 'source' }
      //   }
      // ]);
      setTripMarker((prev: any[]) => {
        const destinationMarker = prev?.find(marker => marker.id === 'destination');

        const sourceMarker = {
          id: 'source',
          lat: sourceAddress?.geometry?.location?.lat() ?? 0,
          lng: sourceAddress?.geometry?.location?.lng() ?? 0,
          name: 'trip',
          info: { Mylocation: 'source' }
        };

        const updatedMarkers = destinationMarker
          ? [sourceMarker, destinationMarker]
          : [sourceMarker];

        return updatedMarkers;
      });
    } else if (sourceAddress) {
      setTripMarker((prev: any) => {
        let updatedMarkers = prev?.map((marker: any) =>
          marker?.id === 'source'
            ? {
                ...marker,
                lat: sourceAddress?.geometry?.location?.lat(),
                lng: sourceAddress?.geometry?.location?.lng()
              }
            : marker
        );
        return updatedMarkers;
      });
    }
  }, [sourceAddress]);

  useEffect(() => {
    setValue('destinationAddress', {
      destination: destinationAddress?.formatted_address,
      endLat: destinationAddress?.geometry?.location?.lat(),
      endLng: destinationAddress?.geometry?.location?.lng()
    });
    clearErrors('destinationAddress');
    const prevMarkers = tripMarker;
    const isDestinationMarker = prevMarkers?.some(
      (marker: any) => marker.id === 'destination'
    );
    if (destinationAddress?.geometry?.location?.lat()) {
      let lat = destinationAddress?.geometry?.location?.lat();
      let lng = destinationAddress?.geometry?.location?.lng();
      let destinationMarker = {
        id: 'destination',
        lat: lat,
        lng: lng,
        name: 'trip',
        info: { Mylocation: 'Destination' }
      };
      if (!isDestinationMarker) {
        setTripMarker((prev: any) => [...prev, destinationMarker]);
      } else {
        setTripMarker((marker: any) => {
          let updatedMarker = marker?.map((item: any) =>
            item?.id === 'destination'
              ? {
                  ...destinationMarker
                }
              : item
          );
          return updatedMarker;
        });
      }
    } else if (isDestinationMarker && destinationAddress) {
      setTripMarker((marker: any) => {
        let updatedMarkers = marker?.filter((item: any) => item?.id !== 'destination');
        return updatedMarkers;
      });
    }
  }, [destinationAddress, selectedRow]);

  useEffect(() => {
    if (tripType === 'SIC' || tripType === 'TSIC') {
      if (tripMarker.length === 2)
        setDestinationMarker(
          tripMarker?.filter((item: any) => item?.id === 'destination')
        );
      setTripMarker((marker: any) => {
        let updatedMarkers = marker?.filter((item: any) => item?.id !== 'destination');
        return updatedMarkers;
      });
    } else if (destinationMarker.length > 0) {
      setTripMarker((prev: any) => [...prev, ...destinationMarker]);
    }
  }, [tripType]);

  useEffect(() => {
    if (tripMarker[0]?.lat && tripMarker[0]?.lng) {
      dispatch(updateCenter(tripMarker));
      dispatch(updateZoom(tripMarker));
    }
  }, [tripMarker]);

  useEffect(() => {
    if (data?.userId && (data?.role === 'ROLE_AGENT' || data?.role === 'ROLE_SUB_AGENT'))
      setValue('agentname', data?.userId);
  }, [data]);

  // useEffect(() => {
  //   setValidationErrorsMake(contactError?.data);
  // }, [contactError]);

  useEffect(() => {
    if (validationErrors.phone) {
      trigger('phone');
    }
  }, [validationErrors.phone]);
  useEffect(() => {
    if (validationErrors.contactNumber) {
      trigger('contactNumber');
    }
  }, [validationErrors.contactNumber]);

  useEffect(() => {
    if (validationErrors.transferContactNumber) {
      trigger('transferContactNumber');
    }
  }, [validationErrors.transferContactNumber]);

  useEffect(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const formattedToday = formatDate(today);
    setValue('tripDate', formattedToday);
    clearErrors('tripDate');
    setEpocvalue(dayjs(today).unix());
    if (!selectedRow) {
      setValue('route', 'Standard');
      setVehicleType('Internal');
      setValue('vehicleType', 'Internal');
      setPvtRoute('Standard');
      setValue('bufferTime', dayjs('00:20', 'HH:mm'));
    }
  }, []);

  return (
    <Box className='add-trip-component'>
      <Dialog
        open={isOpen}
        fullScreen
        sx={{ padding: 3, zIndex: 5, position: 'absolute' }}
        className='add-trip-dialog animate__animated animate__zoomIn'
        BackdropProps={{
          invisible: true
        }}
      >
        <DialogContent
          sx={{ overflow: 'hidden', padding: 0 }}
          className='add-trip-dialog-content'
        >
          <Grid
            container
            sx={{
              flexDirection: { xs: 'column-reverse', md: 'row', sm: 'row' }
            }}
            className='add-trip-grid-container'
          >
            <Grid item xs={12} md={8} sm={8} lg={9} sx={{ overflow: 'hidden' }} p={2}>
              <Box
                sx={{
                  width: '100%',
                  height: '87vh',
                  overflow: { xs: 'scroll', md: 'hidden' },
                  borderRadius: '10px'
                }}
              >
                <GoogleMap>
                  <GoogleTripDirections
                    locations={tripMarker}
                    isDraggable={true}
                    setTripMarker={setTripMarker}
                    handleMarker={handleMarkerDrag}
                    showPath={true}
                  />
                </GoogleMap>
              </Box>
            </Grid>
            <Grid item xs={12} md={4} sm={4} lg={3} className='add-trip-grid-item'>
              <Box className='add-trip-header'>
                <Typography className='add-booking-title'>
                  {selectedRow?.tripID ? 'Update Ad-hoc' : 'Add Ad-hoc'}
                </Typography>
              </Box>
              <Box
                className='closeIcon icon-position d-flex close-icon-index'
                onClick={() => handleClose()}
              >
                <CustomIconButton category='CloseValue' />
              </Box>
              <Box
                className='add-trip-form animate__animated animate__zoomIn animate__slow'
                component='form'
                sx={{
                  height: 'fit-content',
                  maxHeight: '82vh',
                  overflowY: 'auto',
                  paddingRight: '15px'
                }}
                onSubmit={handleSubmit(onSubmit)}
              >
                <CustomSelect
                  id='agent-name'
                  control={control}
                  name='agentname'
                  label='Agent Name'
                  placeholder='Agent name'
                  options={Agents}
                  onChanges={(e: any, newValue: any) => {
                    setValue('agentname', newValue?.id);
                    if (!APagent && !APsubAgent) {
                      handleVehicleDropdown();
                    }
                  }}
                />
                <CustomTextField
                  id='guest-name'
                  control={control}
                  name='guestname'
                  label='Guest Name'
                  placeholder='Guest name'
                  maxlength={20}
                  onChangeCallback={e => {
                    setValue('guestname', e);
                    if (!APagent && !APsubAgent) {
                      handleVehicleDropdown();
                    }
                  }}
                />
                <Controller
                  name='phone'
                  control={control}
                  // defaultValue={selectedRow?.guestContactNumber || '+65'}
                  defaultValue={selectedRow?.guestContactNumber || ''}
                  rules={{ required: true }}
                  render={({ field }: any) => (
                    <PhoneNoTextField
                      {...field}
                      setValue={setValue}
                      isOptional={true}
                      style='share'
                      label='Contact Number'
                      error={Boolean(errors?.phone?.message)}
                      helperText={errors.phone?.message}
                      onChange={(e: any) => {
                        if (e) {
                          const emptySpace = /^.+\s.+$/g;

                          if (e && !emptySpace.test(e)) {
                            handleValidate(e, 'phone');
                          }
                        } else {
                          setValue('phone', '');
                        }
                        trigger('phone');
                      }}
                    />
                  )}
                />
                <Grid container spacing={1} className='adult-count-field'>
                  <Grid item sm={6}>
                    <CustomTextField
                      id='adult-count'
                      control={control}
                      type='number'
                      name='adultcount'
                      label='Adult Count'
                      placeholder='Adult count'
                      isDecimal={true}
                      onChangeCallback={(e: any) => {
                        setValue('adultcount', e);
                        if (!APagent && !APsubAgent) {
                          handleVehicleDropdown();
                        }
                      }}
                    />
                  </Grid>
                  <Grid item sm={6} className='child-count-field'>
                    <CustomTextField
                      id='child-count'
                      control={control}
                      type='number'
                      name='childcount'
                      label='Child Count'
                      isOptional={true}
                      isDecimal
                      defaultValue=''
                      placeholder='Child count'
                      onChangeCallback={(e: any) => {
                        setValue('childcount', e);
                        const value = e?.target?.value;
                        // if (value && value < 0) {
                        //   setValue('childcount', 0);
                        // } else {
                        //   setValue('childcount', value || 0);
                        // }
                        if (!APagent && !APsubAgent) {
                          handleVehicleDropdown();
                        }
                      }}
                    />
                  </Grid>
                </Grid>
                <CustomTextField
                  id='reference-no'
                  control={control}
                  name='referenceno'
                  label='Reference No'
                  placeholder='Reference no'
                  isOptional={true}
                  onChangeCallback={(e: any) => {
                    setValue('referenceno', e);
                    if (!APagent && !APsubAgent) {
                      handleVehicleDropdown();
                    }
                  }}
                />
                <CustomSelect
                  id='trip-type'
                  control={control}
                  label='Tour Mode'
                  placeholder='Tour mode'
                  options={tripTypes}
                  name='triptype'
                  onChanges={(event: any, newValue: Select) => {
                    setValue('triptype', newValue?.id);
                    setTripType(newValue?.label);
                    dispatch(
                      autoPlannerRoutesAction({
                        mode: newValue?.label,
                        currentSecond: dayjs()
                          .tz(profile.timezone)
                          .format('HH:mm:ss')
                          .split(':')
                          .map(Number)
                          .reduce((acc: any, time: any) => 60 * acc + +time)
                      })
                    ); //////
                    clearErrors('triptype');
                    setValue('configuredRoute', '');
                    setValue('sourceAddress.source', '');
                    setSourceAddress(null);
                    setTripMarker([]);
                    setPvtRoute('Standard');
                    setValue('route', 'Standard');
                    setDestinationAddress(null);
                    setValue('configuredRoute', '');
                    setStartDate(null);
                    setValue('startdate', '');
                    // setValue('bufferTime', dayjs('00:20', 'HH:mm'));
                    if (['PVT', 'GRP']?.includes(newValue?.id)) {
                      setValue('tripDate', '');
                      setEpocvalue(null);
                    } else {
                      const today = new Date();
                      today.setHours(0, 0, 0, 0);
                      const formattedToday = formatDate(today);
                      setValue('tripDate', formattedToday);
                      clearErrors('tripDate');
                      setEpocvalue(dayjs(today).unix());
                      setValue('route', 'Standard');
                    }
                    clearErrors([
                      'tripDate',
                      'configuredRoute',
                      'bufferTime',
                      'startdate',
                      'sourceAddress'
                    ]);

                    if (!APagent && !APsubAgent) {
                      handleVehicleDropdown();
                    }
                  }}
                />
                {tripType !== null && tripType !== undefined && (
                  <GoogleSearchBox
                    id='search-source'
                    name='sourceAddress'
                    control={control}
                    label='Pickup Location'
                    placeholder='Search Location..'
                    value={sourceAddress?.formatted_address}
                    // setAddress={setSourceAddress}
                    setAddress={(place: any) => {
                      setSourceAddress(place);
                      // Set full delivery address and lat/lng from selected place
                      setValue('sourceAddress.source', place?.formatted_address || '');
                      setValue(
                        'sourceAddress.startLat',
                        place?.geometry?.location?.lat() || null
                      );
                      setValue(
                        'sourceAddress.startLng',
                        place?.geometry?.location?.lng() || null
                      );
                      if (!APagent && !APsubAgent) {
                        handleVehicleDropdown();
                      }
                    }}
                    country='sg'
                    onchange={(e: any, data: any) => {
                      if (!e?.target?.value) {
                        setValue('sourceAddress' as any, null);
                        setSourceAddress(null);
                        setTripMarker((prev: any) =>
                          prev.filter((item: any) => item?.id !== 'source')
                        );
                        if (!APagent && !APsubAgent) {
                          handleVehicleDropdown();
                        }
                      }
                    }}
                  />
                )}

                {tripType === 'PVT' || tripType === 'GRP' ? (
                  <CustomRadioButton
                    name='route'
                    control={control}
                    formlabel='Select Route Type'
                    radiobutton2='Standard'
                    radiobutton1='Custom'
                    value2='Standard'
                    value1='Custom'
                    value={pvtRoute}
                    onChangeCallback={e => {
                      setPvtRoute(e.target.value);
                      setValue('route', e.target.value);
                      setValue('configuredRoute', '');
                      setValue('destinationAddress', {
                        destination: '',
                        endLat: null,
                        endLng: null
                      });
                      setTripMarker((prev: any) =>
                        prev.filter((item: any) => item.id !== 'destination')
                      );
                      setDestinationAddress(null);
                      // setValue('startdate', '');
                      setValue('bufferTime', dayjs('00:20', 'HH:mm'));
                    }}
                  />
                ) : (
                  ''
                )}

                {(tripType === 'PVT' || tripType === 'GRP') && (
                  <>
                    {pvtRoute === 'Custom' ? (
                      <GoogleSearchBox
                        id='search-destination'
                        name='destinationAddress'
                        control={control}
                        label='Drop Location'
                        placeholder='Search Location..'
                        value={destinationAddress?.formatted_address}
                        // setAddress={setDestinationAddress}
                        country='sg'
                        onchange={(e: any) => {
                          if (!e?.target?.value) {
                            setValue('destinationAddress' as any, null);
                            setDestinationAddress(null);
                            setTripMarker((prev: any) =>
                              prev.filter((item: any) => item.id !== 'destination')
                            );
                          }
                          if (!APagent && !APsubAgent) {
                            handleVehicleDropdown();
                          }
                        }}
                        setAddress={(place: any) => {
                          setDestinationAddress(place);
                          // setValue(
                          //   'destinationAddress.destination',
                          //   place?.formatted_address || ''
                          // );
                          // setValue(
                          //   'sourceAddress.startLat',
                          //   place?.geometry?.location?.lat() || null
                          // );
                          // setValue(
                          //   'sourceAddress.startLng',
                          //   place?.geometry?.location?.lng() || null
                          // );
                          setValue('destinationAddress', {
                            destination: place?.formatted_address || '',
                            endLat: place?.geometry?.location?.lat() || null,
                            endLng: place?.geometry?.location?.lng() || null
                          });
                          if (!APagent && !APsubAgent) {
                            handleVehicleDropdown();
                          }
                        }}
                      />
                    ) : (
                      <CustomSelect
                        id='configured-route'
                        control={control}
                        label='Tour Name'
                        loading={isLoading}
                        placeholder='Select Tour Name'
                        options={configuredRoute}
                        name='configuredRoute'
                        onChanges={(event: any, newValue: any) => {
                          setValue('configuredRoute', newValue?.id);
                          setTourName(newValue?.label);
                          clearErrors('triptype');
                          if (newValue?.is === 0) {
                            setValue('isTime', false);
                            setTimeReq(0);
                          } else {
                            setValue('isTime', true);
                            setTimeReq(1);
                          }
                          setValue('startdate', '');
                          // setValue('startdate', '');
                          // setValue('bufferTime', '');
                          // setValue('tripDate', '');
                          setEpocvalue(null);
                          setStartDate(null);
                          if (!APagent && !APsubAgent) {
                            handleVehicleDropdown();
                          }
                        }}
                      />
                    )}
                  </>
                )}

                {tripType !== null && tripType !== undefined && (
                  <>
                    {tripType === 'PVT' || tripType === 'GRP' ? (
                      <>
                        <CustomDateTimeCalendar
                          id='startdate'
                          control={control}
                          name='startdate'
                          label='Pickup Date & Time'
                          disableFuture={false}
                          disablePast={true}
                          enableTodayDate={true}
                          value={startDate}
                          // minDateTime={
                          //   profile?.timezone &&
                          //   dayjs().tz(profile?.timezone).add(1, 'day').startOf('day')
                          // }
                          format='DD/MM/YYYY hh:mm a'
                          placeholder='DD/MM/YYYY HH:MM'
                          onDateChange={(e: any) => {
                            if (e) {
                              setStartDate(e?.$d);
                              setValue(
                                'startdate',
                                dayjs.unix(convertDatetoEpoch(e?.$d) / 1000)
                              );
                              clearErrors('startdate');
                            } else {
                              setValue('startdate' as any, null);
                            }
                            if (!APagent && !APsubAgent) {
                              handleVehicleDropdown();
                            }
                          }}
                        />
                        <CustomTimePicker
                          id='bufferTime'
                          name='bufferTime'
                          control={control}
                          values={getValues('bufferTime')}
                          setDefaultToTime={true}
                          minTime={dayjs('00:20', 'HH:mm')}
                          label='Buffer Time'
                          views={['hours', 'minutes']}
                          format='HH:mm'
                          isClock={false}
                          isOptional={true}
                          onTimeChange={() => {
                            if (!APagent && !APsubAgent) {
                              handleVehicleDropdown();
                            }
                          }}
                        />
                        <Alert
                          sx={{
                            marginBottom: '5px',
                            padding: '5px 10px',
                            alignItems: 'center',
                            fontSize: '12px'
                          }}
                          severity='warning'
                        >
                          By default, a buffer time of 20 minutes will be applied unless
                          specified.
                        </Alert>
                      </>
                    ) : (
                      <>
                        <CustomSelect
                          id='configured-route'
                          control={control}
                          label='Tour Name'
                          loading={isLoading}
                          placeholder='Tour name'
                          options={configuredRoute}
                          name='configuredRoute'
                          onChanges={(event: any, newValue: any) => {
                            setValue('configuredRoute', newValue?.id);
                            if (newValue?.is === 0) {
                              setValue('isTime', false);
                              setTimeReq(0);
                            } else {
                              setValue('isTime', true);
                              setTimeReq(1);
                            }
                            // setValue('startdate', '');
                            // setValue('bufferTime', '');
                            // setValue('tripDate', '');
                            // setEpocvalue(null);
                            setTourName(newValue?.label);
                            clearErrors('triptype');
                            setValue('startdate', '');
                            setStartDate(null);
                            if (!APagent && !APsubAgent) {
                              handleVehicleDropdown();
                            }
                          }}
                        />
                        {timeReq === 1 && (
                          <CustomDateTimeCalendar
                            id='startdate'
                            control={control}
                            name='startdate'
                            label='Pickup Date & Time'
                            disableFuture={false}
                            disablePast={true}
                            enableTodayDate={true}
                            // minDateTime={dayjs().add(1, 'day').startOf('day')}
                            value={startDate}
                            format='DD/MM/YYYY hh:mm a'
                            placeholder='DD/MM/YYYY HH:MM'
                            onDateChange={(e: any) => {
                              if (e) {
                                setStartDate(e?.$d);
                                setValue(
                                  'startdate',
                                  dayjs.unix(convertDatetoEpoch(e?.$d) / 1000)
                                );
                                clearErrors('startdate');
                              }
                              if (!APagent && !APsubAgent) {
                                handleVehicleDropdown();
                              }
                            }}
                          />
                        )}
                        {timeReq === 0 && (
                          <CustomDateCalendar
                            isDisabled={true}
                            id='trip-date'
                            name='tripDate'
                            control={control}
                            type='user-profile'
                            className='calendar'
                            label='Trip Date'
                            placeholder='Select Trip Date'
                            minDate={dayjs().startOf('day')}
                            maxDate={dayjs().startOf('day')}
                            disablePast={true}
                            value={epocvalue ? dayjs.unix(epocvalue) : null}
                            onDateChange={(date: any) => {
                              setStartDate(date.$d);

                              setValue('tripDate', formatDate(date?.$d));
                              clearErrors('tripDate');
                              if (!APagent && !APsubAgent) {
                                handleVehicleDropdown();
                              }
                            }}
                          />
                        )}
                      </>
                    )}
                  </>
                )}

                <>
                  {!APagent && !APsubAgent ? (
                    <>
                      <CustomRadioButton
                        name='vehicleType'
                        control={control}
                        formlabel='Select Vehicle Type'
                        radiobutton1='Internal'
                        radiobutton2='External'
                        value1='Internal'
                        value2='External'
                        value={vehicleType}
                        onChangeCallback={e => {
                          dispatch(clearAdhocTransferVehicle());
                          setVehicleType(e.target.value);
                          setValue('vehicleType', e.target?.value);
                          if (e.target.value === 'Internal') {
                            if (!APagent && !APsubAgent) {
                              handleVehicleDropdown();
                            }
                            setTransferVehicleType('Internal');
                          }

                          setValue('vehicleNumber', '');
                          setValue('driverName', '');
                          setValue('contactNumber', '');
                          resetField('seatingCapacity');
                          resetField('transferCapacity');
                          setValue('transferVehicleNumber', '');
                          setValue('transferDriverName', '');
                          setValue('transferContactNumber', '');

                          clearErrors([
                            'vehicleNumber',
                            'driverName',
                            'contactNumber',
                            'seatingCapacity',
                            'transferVehicleNumber',
                            'transferDriverName',
                            'transferContactNumber',
                            'transferCapacity'
                          ]);

                          // trigger('vehicleNumber');

                          // setPvtRoute(e.target.value);
                          // setValue('route', e.target.value);
                          // setValue('configuredRoute', '');
                          // setValue('destinationAddress', {
                          //   destination: '',
                          //   endLat: null,
                          //   endLng: null
                          // });
                          // setTripMarker((prev: any) =>
                          //   prev.filter((item: any) => item.id !== 'destination')
                          // );
                          // setDestinationAddress(null);
                          // setValue('startdate', '');
                          // setValue('bufferTime', '');
                          // setValue('tripDate', '');
                          // setEpocvalue(null);
                          // setStartDate(null);
                        }}
                      />

                      {vehicleType === 'Internal' && (
                        <Alert
                          sx={{
                            marginBottom: '5px',
                            padding: '5px 10px',
                            alignItems: 'center',
                            fontSize: '12px'
                          }}
                          severity='info'
                        >
                          R - Remaining Seating Capacity
                          <br /> A - Actual Seating Capacity
                        </Alert>
                      )}

                      {vehicleType === 'Internal' ? (
                        <CustomSelect
                          isDisabled={!isVehicleNumberEnable}
                          id='vehicle-number'
                          loading={getAdhocLoading}
                          control={control}
                          name='vehicleNumber'
                          label='Vehicle Number'
                          placeholder='Vehicle number'
                          options={adhocDropdown ?? []}
                          onChanges={(e: any, newValue: any) => {
                            handleTansferVehicleDropdown(newValue);
                            setTransferVehicleType('Internal');
                            setValue('transferVehicleNumber', '');
                            clearErrors('transferVehicleNumber');
                            setValue('transferDriverName', '');
                            setValue('transferContactNumber', '');
                          }}
                        />
                      ) : (
                        <>
                          <CustomTextField
                            id='vehicle-number'
                            control={control}
                            name='vehicleNumber'
                            label='Vehicle Number'
                            placeholder='Vehicle number'
                            maxlength={20}
                          />
                          <CustomTextField
                            id='driver-name'
                            control={control}
                            name='driverName'
                            label='Driver Name'
                            placeholder='Driver name'
                            maxlength={20}
                          />
                          <Controller
                            name='contactNumber'
                            control={control}
                            defaultValue={selectedRow?.guestContactNumber || '+65'}
                            rules={{ required: true }}
                            render={({ field }: any) => (
                              <PhoneNoTextField
                                {...field}
                                setValue={setValue}
                                country='sg'
                                style='share'
                                label='Driver Contact Number'
                                disableCountry={true}
                                error={Boolean(errors?.contactNumber?.message)}
                                helperText={errors.contactNumber?.message}
                                onChange={(e: any) => {
                                  if (e) {
                                    const emptySpace = /^.+\s.+$/g;
                                    if (e && !emptySpace.test(e)) {
                                      handleValidate(e, 'contactNumber');
                                    }
                                  } else {
                                    setValue('contactNumber', '');
                                  }
                                  trigger('contactNumber');
                                }}
                              />
                            )}
                          />
                          <CustomTextField
                            id='seating-capacity'
                            control={control}
                            type='number'
                            name='seatingCapacity'
                            label='Seating Capacity'
                            placeholder='Seating Capacity'
                            isDecimal={true}
                            onChangeCallback={(e: any) => {
                              setValue('seatingCapacity', e);
                            }}
                          />
                        </>
                      )}
                    </>
                  ) : (
                    ''
                  )}
                </>

                {/* transfer vehicle fields  */}
                {adhocTransferVehicle?.data?.mainHotelResponses?.length > 0 &&
                  vehicleType === 'Internal' &&
                  ['SIC', 'TSIC']?.includes(tripType) && (
                    <>
                      <CustomRadioButton
                        name='transferVehicleType'
                        control={control}
                        formlabel='Select Transfer Vehicle Type'
                        radiobutton1='Internal'
                        radiobutton2='External'
                        value1='Internal'
                        value2='External'
                        value={transferVehicleType}
                        onChangeCallback={e => {
                          // setVehicleType(e.target.value);
                          setTransferVehicleType(e.target.value);
                          setValue('transferVehicleNumber', '');
                          clearErrors('transferVehicleNumber');
                          setValue('transferDriverName', '');
                          setValue('transferContactNumber', '');
                        }}
                      />
                      {transferVehicleType === 'Internal' ? (
                        <CustomSelect
                          loading={getTransferAdhocLoading}
                          id='transfer-vehicle-number'
                          control={control}
                          name='transferVehicleNumber'
                          label='Transfer Vehicle Number'
                          placeholder='Transfer vehicle number'
                          options={adhocTransferDropdown || []}
                          onChanges={(e: any, newValue: any) =>
                            setValue('transferVehicleNumber', newValue?.id)
                          }
                        />
                      ) : (
                        <>
                          <CustomTextField
                            id='vehicle-number'
                            control={control}
                            name='transferVehicleNumber'
                            label='Vehicle Number'
                            placeholder='Vehicle number'
                            maxlength={20}
                            onChangeCallback={e => setValue('transferVehicleNumber', e)}
                          />
                          <CustomTextField
                            id='driver-vname'
                            control={control}
                            name='transferDriverName'
                            label='Driver Name'
                            placeholder='Driver name'
                            maxlength={20}
                            onChangeCallback={e => setValue('transferDriverName', e)}
                          />
                          <Controller
                            name='transferContactNumber'
                            control={control}
                            defaultValue={selectedRow?.guestContactNumber || '+65'}
                            rules={{ required: true }}
                            render={({ field }: any) => (
                              <PhoneNoTextField
                                {...field}
                                setValue={setValue}
                                country='sg'
                                style='share'
                                label='Driver Contact Number'
                                disableCountry={true}
                                error={Boolean(errors?.transferContactNumber?.message)}
                                helperText={errors.transferContactNumber?.message}
                                onChange={(e: any) => {
                                  if (e) {
                                    const emptySpace = /^.+\s.+$/g;
                                    if (e && !emptySpace.test(e)) {
                                      handleValidate(e, 'transferContactNumber');
                                    } else {
                                      setValue('transferContactNumber', '');
                                    }
                                    trigger('transferContactNumber');
                                  }
                                }}
                              />
                            )}
                          />
                          <CustomTextField
                            id='transfer-capacity'
                            control={control}
                            type='number'
                            name='transferCapacity'
                            label='Seating capacity'
                            placeholder='Seating Capacity'
                            isDecimal={true}
                            onChangeCallback={(e: any) => {
                              setValue('transferCapacity', e);
                            }}
                          />
                        </>
                      )}
                      <Alert
                        sx={{
                          marginBottom: '5px',
                          padding: '5px 10px',
                          alignItems: 'center',
                          fontSize: '12px'
                        }}
                        severity='warning'
                      >
                        {`Main Hotel -
                          ${adhocTransferVehicle?.data?.mainHotelResponses[0]?.coordinates?.locationAddress}`}
                      </Alert>
                    </>
                  )}

                <Box mt={3} sx={{ textAlign: 'right' }}>
                  <CustomButton
                    category='Cancel'
                    className='cancel'
                    sx={{ marginRight: '10px' }}
                    onClick={() => handleClose()}
                  />
                  <CustomButton
                    category={selectedRow?.tripID ? 'Save' : 'Save'}
                    loading={
                      // updateData?.isLoading ||
                      // addData?.isLoading ||
                      updateAdhocLoading ||
                      BookingUpdateLoading ||
                      AddAdhocLoading ||
                      sicBookingUpdateLoading ||
                      pvtBookingUpdateLoading
                    }
                    className='saveChanges'
                    type='submit'
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default AddAdhocTrip;
